// Libraries
import React from 'react';

// Supermove
import {Popover, PopoverProps, Styled} from '@supermove/components';
import {PopoverType, useResponsive} from '@supermove/hooks';
import {colors, Typography} from '@supermove/styles';

import TertiaryButton from '@shared/design/components/Button/TertiaryButton';
import TextTooltip from '@shared/design/components/TextTooltip';

const PopoverContentContainer = Styled.View<{width: number}>`
  width: ${({width}) => width}px;
  border-radius: 4px;
  position: absolute;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
  background-color: ${colors.white};
  padding-vertical: 8px;
`;

const PopoverDropdownText = Styled.Text<{disabled?: boolean}>`
  ${Typography.Responsive.Body}
  color: ${({disabled}) => (disabled ? colors.gray.secondary : undefined)};
`;

interface Action {
  text?: string;
  onPress?: () => void;
  tooltip?: string;
  isDisabled?: boolean;
}

interface WidgetPopoverProps {
  ButtonComponent: React.ReactNode;
  popover: PopoverType;
  popoverProps?: Partial<PopoverProps>;
  width?: number;
  actions: Action[];
}

const ProjectPopoverButton = ({
  ButtonComponent,
  popover,
  popoverProps,
  width = 248,
  actions,
}: WidgetPopoverProps) => {
  const responsive = useResponsive();
  return (
    <React.Fragment>
      <Popover.Content innerRef={popover.ref}>
        <TertiaryButton onPress={popover.handleToggle}>{ButtonComponent}</TertiaryButton>
      </Popover.Content>
      <Popover
        isOpen={popover.isOpen}
        handleOpen={popover.handleOpen}
        handleClose={popover.handleClose}
        placement={Popover.Positions.BottomStart}
        reference={popover.ref}
        {...popoverProps}
      >
        <PopoverContentContainer width={width}>
          {actions.map((action) => (
            <TertiaryButton
              key={action.text}
              onPress={action.onPress}
              style={{
                paddingHorizontal: 16,
                paddingVertical: 16,
                flex: 1,
                justifyContent: 'flex-start',
              }}
              isDisabled={action.isDisabled}
            >
              <TextTooltip text={action.tooltip} placement={'top'}>
                <PopoverDropdownText disabled={action.isDisabled} responsive={responsive}>
                  {action.text}
                </PopoverDropdownText>
              </TextTooltip>
            </TertiaryButton>
          ))}
        </PopoverContentContainer>
      </Popover>
    </React.Fragment>
  );
};

export default ProjectPopoverButton;
